module.exports = __webpack_public_path__ + "img/panela.6f8186f6.svg";